var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mls_ids)?_c('m-l-s-powered-listings',{attrs:{"team-slug":_vm.teamSlugOrOverride,"mls-ids":_vm.mls_ids}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }